export default __webpack_public_path__ + "static/media/Mayor.eb56d1d2.webp";